'use client';

import Text from '@/components/ui/Text';
import { BlogI18n } from '@/lib/i18n/blogI18n';

const BlogEmptyState = ({ t, onClear }: BlogEmptyStateProps) => (
  <div className="mt-12 flex flex-col items-start gap-3">
    <Text as="p" variant="paragraph" className="text-text-secondary mb-0!">
      {t.noResults}
    </Text>
    <button
      onClick={onClear}
      className="text-sm font-medium text-primary hover:underline cursor-pointer"
    >
      {t.clearSearch}
    </button>
  </div>
);

export default BlogEmptyState;

type BlogEmptyStateProps = {
  t: BlogI18n;
  onClear: () => void;
};
